import React from 'react';
import { Placeholder, Table } from 'react-bootstrap';

export interface ITableColumn {
    label: string;
    className?: string;
}

interface ITableSkeleton {
    columns: ITableColumn[];
    rows?: number;
}

const DEFAULT_ROWS = 10;
const CELL_WIDTHS = [8, 6, 10, 5, 7];

function SkeletonCell({ width }: { width: number }) {
    return (
        <Placeholder as="span" animation="glow" className="d-block">
            <Placeholder xs={width} className="skeleton" />
        </Placeholder>
    );
}
export function TableSkeletonRows({ columns, rows = DEFAULT_ROWS }: { columns: number; rows?: number }) {
    return (
        <>
            {Array.from({ length: rows }).map((_, r) => (
                <tr key={r} aria-hidden="true">
                    {Array.from({ length: columns }).map((_, c) => (
                        <td key={c}>
                            <SkeletonCell width={CELL_WIDTHS[(r + c) % CELL_WIDTHS.length]} />
                        </td>
                    ))}
                </tr>
            ))}
        </>
    );
}
export default function TableSkeleton({ columns, rows = DEFAULT_ROWS }: ITableSkeleton) {
    return (
        <Table responsive aria-busy="true">
            <thead>
                <tr>
                    {columns.map(column => (
                        <th key={column.label} className={column.className}>
                            {column.label}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                <TableSkeletonRows columns={columns.length} rows={rows} />
            </tbody>
        </Table>
    );
}
